export const DOMAIN_TYPES = {
  FEDERATED: "Federated",
  NON_FEDERATED: "Non-Federated",
  RESTRICTED_NON_FEDERATED: "Restricted-Non-Federated",
};